module.exports = __webpack_public_path__ + "img/abs015.bcf5bd2d.svg";